import { PayloadAction } from '@reduxjs/toolkit';
import { NOTICE_TYPES } from 'common/constants/notice';
import { EMPTY_STRING } from 'common/constants';
import { IState } from '../types';
import { IProps } from '../types/notice';

const setSuccess = (state: IState, { payload }: PayloadAction<IProps>) => {
  const {
    title: text = EMPTY_STRING,
    translateId = EMPTY_STRING,
    data = {},
    hideActions,
    icon,
  } = payload || {};
  state.notice = [
    {
      id: `${new Date().getTime()}`,
      text,
      translateId,
      data,
      type: NOTICE_TYPES.success,
      hideActions,
      icon,
    },
    ...(state.notice || []).slice(0, 2),
  ];
};

export default setSuccess;
